/**
 * svg描画用
 * 
 * HTMLのクラス属性にiconから始まるクラス名が付与されている場合、後に続く文字列に応じてsvgを出力します。
 */
const Drawing = () => {
    const icons = document.querySelectorAll(`[class^="icon-"]`);
    for (let icon of icons) {
        const svgName = getSVGFileName(icon.className);
        if (!svgName) continue;

        let svg = null;
        try {
            svg = require(`svg-inline-loader?classPrefix!../../img/common/${svgName}.svg`);
        } catch(e) {
            console.error(e);
            continue;
        }

        icon.innerHTML = svg;
    }
};

/**
 * クラス属性をパースしてファイル名と紐づく文字列を返します
 * 
 * @param {String} classStr クラス属性文字列
 * @return {String} SVGファイル名
 */
const getSVGFileName = (classStr) => {
    const classes = classStr.split(' ');
    const filteredClass = classes.filter((className) => {
        return /^icon-/.test(className);
    });

    if (filteredClass.length <= 0) return false;

    const iconClass = filteredClass[0];
    const svgName = iconClass.split('-');

    if (svgName.length < 2) return false;

    return svgName[1];
};

module.exports = window.addEventListener('DOMContentLoaded', Drawing);


// WEBPACK FOOTER //
// ./js/modules/logo.js